import { render, staticRenderFns } from "./albumBackup.vue?vue&type=template&id=1b8c823e&scoped=true"
import script from "./albumBackup.vue?vue&type=script&lang=js"
export * from "./albumBackup.vue?vue&type=script&lang=js"
import style0 from "./albumBackup.vue?vue&type=style&index=0&id=1b8c823e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c823e",
  null
  
)

export default component.exports